module.exports = __webpack_public_path__ + "static/media/shoot-logo.be75a6f0.png";